import React, { useEffect, useRef } from 'react';

const PLUS_CODE = '427G+X6 Wrocław';

const GRAYSCALE_STYLES = [
  { featureType: 'all', stylers: [{ saturation: -100 }] },
];

function GoogleMapEmbed() {
  const mapRef = useRef(null);

  useEffect(() => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    function initMap() {
      if (!mapRef.current) return;

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ address: PLUS_CODE }, (results, status) => {
        if (status !== 'OK' || !results || results.length === 0) return;

        const position = results[0].geometry.location;

        const map = new window.google.maps.Map(mapRef.current, {
          center: position,
          zoom: 16,
          styles: GRAYSCALE_STYLES,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
        });

        new window.google.maps.Marker({
          position,
          map,
          title: 'Magdalena Pawlak Kancelaria Radcy Prawnego',
        });
      });
    }

    if (window.google && window.google.maps) {
      initMap();
      return;
    }

    if (document.querySelector('script[data-gmaps]')) {
      const interval = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(interval);
          initMap();
        }
      }, 100);
      return () => clearInterval(interval);
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    script.dataset.gmaps = 'true';
    script.onload = initMap;
    document.head.appendChild(script);
  }, []);

  return (
    <div
      ref={mapRef}
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
    />
  );
}

export default GoogleMapEmbed;
